import {ServiceConfig} from "../../../model/config/service-config"
import {otsBaseApi} from "../../ots-api";
import {Capability, CapabilityGroup} from "../../../model/config/capability";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ServiceConfig", "ServiceCapabilities", "ServiceGroupedCapabilities"]});

const serviceConfigApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getServiceConfig: builder.query<ServiceConfig, void>({
      query: () => ({
        url: `/config/service`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "ServiceConfig", id: "LIST"}]
    }),
    getCapabilities: builder.query<Capability[], void>({
      query: () => ({
        url: `/config/capabilities`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "ServiceCapabilities", id: "LIST"}]
    }),
    getGroupedCapabilities: builder.query<CapabilityGroup[], void>({
      query: () => ({
        url: `/config/capabilities/grouped`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "ServiceGroupedCapabilities", id: "LIST"}]
    }),
  })
});

export const {
  useGetServiceConfigQuery,
  useGetCapabilitiesQuery,
  useGetGroupedCapabilitiesQuery,
} = serviceConfigApi;
